/* =====================================================================
   The Petrait — Custom background ("Design your own")
   ---------------------------------------------------------------------
   Ativa-se sozinho quando a opção nativa "Color" do produto tem um valor
   chamado exatamente "Custom". Se esse valor não existir, não faz nada.

   - Transforma o swatch "Custom" num círculo com "+"
   - Ao escolhê-lo, abre um pop-up: cor de fundo + ícone a repetir
   - Guarda as respostas como propriedades do item da encomenda:
       "Custom background color" e "Custom background icon"
   - Não deixa avançar do passo 1 (nem adicionar ao carrinho) sem as
     duas respostas preenchidas
   - Não mexe em nada dentro do formulário da Tepo
   - Layout B dos fundos: caixa "Solid" + caixa "Premium" (qualquer número
     de swatches) e a linha "Design your own" por baixo
   ===================================================================== */
(function () {
  var VALUE = 'Custom';
  var OPTION_PREFIX = 'Color';
  var PROP_COLOR = 'properties[Custom background color]';
  var PROP_ICON = 'properties[Custom background icon]';

  var COLORS = [
    ['Yellow', '#F7DF98'],
    ['Coral', '#EFB1A1'],
    ['Soft Pink', '#FFE6ED'],
    ['Dark Pink', '#EBA3AE'],
    ['Soft Purple', '#E8D1E5'],
    ['Soft Blue', '#D5E1EF'],
    ['Sky Blue', '#A1C9D9'],
    ['Green', '#D7DE9E'],
    ['Brown', '#C2A797'],
    ['Soft Beige', '#F2E6DE']
  ];

  var state = { color: '', icon: '' };
  var overlay = null;
  var fieldsBox = null;
  var savedTimer = null;
  var SAVED_MS = 900;

  var ICON_PLUS = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';
  var ICON_EYE = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" stroke="currentColor" stroke-width="1.6" fill="none"/><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';

  /* ---------- helpers ---------- */

  function customInputs() {
    return Array.prototype.filter.call(
      document.querySelectorAll('input[type="radio"][value="' + VALUE + '"]'),
      function (i) { return (i.name || '').indexOf(OPTION_PREFIX) === 0; }
    );
  }

  function isCustomSelected() {
    return customInputs().some(function (i) { return i.checked; });
  }

  function colorText() {
    return state.color;
  }

  function isValid() {
    return !!colorText() && !!state.icon.trim();
  }

  function summaryText() {
    return colorText() + ' · ' + state.icon.trim();
  }

  /* ---------- campos escondidos que vão para a encomenda ---------- */

  function ensureFields() {
    var inputs = customInputs();
    var formId = inputs.length ? inputs[0].getAttribute('form') : null;
    if (!formId) return;

    if (!fieldsBox) {
      fieldsBox = document.createElement('div');
      fieldsBox.id = 'petraitCbgFields';
      fieldsBox.hidden = true;
      fieldsBox.innerHTML =
        '<input type="hidden" data-cbg="color">' +
        '<input type="hidden" data-cbg="icon">';
      document.body.appendChild(fieldsBox);
    }
    var c = fieldsBox.querySelector('[data-cbg="color"]');
    var i = fieldsBox.querySelector('[data-cbg="icon"]');
    c.name = PROP_COLOR;
    i.name = PROP_ICON;
    c.setAttribute('form', formId);
    i.setAttribute('form', formId);
    syncFields();
  }

  function syncFields() {
    if (!fieldsBox) return;
    var on = isCustomSelected() && isValid();
    var c = fieldsBox.querySelector('[data-cbg="color"]');
    var i = fieldsBox.querySelector('[data-cbg="icon"]');
    c.value = on ? colorText() : '';
    i.value = on ? state.icon.trim() : '';
    // inputs desativados não são enviados: só seguem quando o Custom está escolhido
    c.disabled = !on;
    i.disabled = !on;
  }

  /* ---------- swatch "+" e resumo por baixo dos swatches ---------- */

  function decorate() {
    var inputs = customInputs();
    if (!inputs.length) return;
    document.documentElement.classList.add('petrait-cbg-on');

    inputs.forEach(function (input) {
      var label = document.querySelector('label[for="' + input.id + '"]');
      if (!label || label.classList.contains('petrait-cbg-swatch')) return;
      label.classList.add('petrait-cbg-swatch');
      label.setAttribute('aria-label', 'Design your own background');
      var tip = label.querySelector('.tooltip');
      if (tip) tip.textContent = 'Design your own';
      var dot = label.querySelector('.swatch-color');
      if (dot) {
        dot.style.setProperty('--swatch-background', '#fff');
        dot.innerHTML = ICON_PLUS;
      }
    });

    renderSummary();
    ensureFields();
  }

  /* ---------- Layout B: caixas Solid / Premium + linha "Design your own" ----------
     Não move nada no DOM do tema: só dá posições na grelha (grid-row / grid-column)
     aos títulos e swatches que o petrait-premium-badge.js já desenha. */

  var customExtra = '';
  var extraLoading = false;
  function loadCustomExtra(fs) {
    if (extraLoading) return;
    extraLoading = true;
    var url = location.pathname.replace(/\/$/, '') + '.js';
    fetch(url).then(function (r) { return r.json(); }).then(function (p) {
      if (!p || !p.variants) return;
      var idx = -1;
      (p.options || []).forEach(function (o, i) {
        var name = (o && o.name ? o.name : o) + '';
        if (idx < 0 && /colou?r|background/i.test(name)) idx = i;
      });
      if (idx < 0) idx = 0;
      var premium = {};
      fs.querySelectorAll(':scope > label').forEach(function (l) {
        if (l.querySelector('.swatch-color[style*="background-image"]')) {
          var inp = document.getElementById(l.getAttribute('for'));
          if (inp) premium[inp.value] = true;
        }
      });
      var minSolid = Infinity, minCustom = Infinity;
      p.variants.forEach(function (v) {
        var val = v.options ? v.options[idx] : v['option' + (idx + 1)];
        if (val === VALUE) minCustom = Math.min(minCustom, v.price);
        else if (!premium[val]) minSolid = Math.min(minSolid, v.price);
      });
      var diff = minCustom - minSolid;
      if (isFinite(diff) && diff > 0) {
        customExtra = '+$' + (diff / 100).toFixed(2).replace(/\.00$/, '');
        document.querySelectorAll('.pt-cbg-price').forEach(function (el) {
          if (el.textContent !== customExtra) el.textContent = customExtra;
        });
      }
    }).catch(function () {});
  }

  function setPos(el, row, col) {
    if (el.getAttribute('data-pt-pos') === row + '|' + col) return;
    el.style.gridRow = row;
    el.style.gridColumn = col;
    el.setAttribute('data-pt-pos', row + '|' + col);
  }

  function buildCustomRow(label) {
    if (!label.querySelector('.pt-cbg-text')) {
      var text = document.createElement('span');
      text.className = 'pt-cbg-text';
      text.innerHTML = '<b>Design your own</b><i>A pattern made just for them</i>';
      var price = document.createElement('span');
      price.className = 'pt-cbg-price';
      price.textContent = customExtra;
      label.appendChild(text);
      label.appendChild(price);
    }
    var sub = label.querySelector('.pt-cbg-text i');
    var want = isCustomSelected() && isValid() ? summaryText() : 'A pattern made just for them';
    if (sub && sub.textContent !== want) sub.textContent = want;
  }

  function layoutB() {
    document.querySelectorAll('fieldset.product-form__input--color[data-swatch-type="color_swatch"]').forEach(function (fs) {
      var labels = Array.prototype.slice.call(fs.querySelectorAll(':scope > label'));
      if (!labels.length) return;
      var hs = fs.querySelector(':scope > .petrait-sw-head--solid');
      var hp = fs.querySelector(':scope > .petrait-sw-head--premium');
      if (!hs || !hp) return; // espera pelos títulos do petrait-premium-badge.js
      var solids = [], prems = [], custom = null;
      labels.forEach(function (l) {
        var inp = document.getElementById(l.getAttribute('for'));
        if (inp && inp.value === VALUE) custom = l;
        else if (l.querySelector('.swatch-color[style*="background-image"]')) prems.push(l);
        else solids.push(l);
      });
      fs.classList.add('pt-bgB');
      setPos(hs, '1 / 3', '1 / -1');
      setPos(hp, '4 / 6', '1 / -1');
      solids.forEach(function (l, i) { setPos(l, '2', String(i + 2)); });
      prems.forEach(function (l, i) { setPos(l, '5', String(i + 2)); });
      if (custom) {
        fs.classList.add('pt-bgB--custom');
        setPos(custom, '7', '1 / -1');
        buildCustomRow(custom);
        loadCustomExtra(fs);
      }
    });
  }

  function renderSummary() {
    var input = customInputs()[0];
    if (!input) return;
    var label = document.querySelector('label[for="' + input.id + '"]');
    if (!label) return;
    // No layout B a própria linha "Design your own" mostra o resumo
    if (label.closest('fieldset.pt-bgB')) {
      buildCustomRow(label);
      var old = document.getElementById('petraitCbgSummary');
      if (old) old.hidden = true;
      return;
    }
    var anchor = label.closest('fieldset') || label.parentElement;
    if (!anchor) return;

    var box = document.getElementById('petraitCbgSummary');
    if (!box) {
      box = document.createElement('div');
      box.id = 'petraitCbgSummary';
      box.className = 'pcbg-summary';
      box.innerHTML =
        '<span class="pcbg-summary__dot"></span>' +
        '<span class="pcbg-summary__text"></span>' +
        '<button type="button" class="pcbg-summary__edit">Edit</button>';
      box.querySelector('.pcbg-summary__edit').addEventListener('click', function () { openModal(); });
    }
    if (box.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', box);

    var show = isCustomSelected() && isValid();
    box.hidden = !show;
    if (show) {
      // só escreve quando muda, para não disparar o observador em loop
      var txt = box.querySelector('.pcbg-summary__text');
      if (txt.textContent !== summaryText()) txt.textContent = summaryText();
      var hex = '';
      COLORS.forEach(function (c) { if (c[0] === state.color) hex = c[1]; });
      box.querySelector('.pcbg-summary__dot').style.background = hex || '#eee';
    }
  }

  /* ---------- pop-up ---------- */

  function buildModal() {
    overlay = document.createElement('div');
    overlay.className = 'pcbg-overlay';
    overlay.hidden = true;

    var dots = COLORS.map(function (c) {
      return '<button type="button" class="pcbg-color" data-color="' + c[0] + '" style="--c:' + c[1] + '" aria-label="' + c[0] + '" title="' + c[0] + '"></button>';
    }).join('');

    overlay.innerHTML =
      '<div class="pcbg-sheet" role="dialog" aria-modal="true" aria-labelledby="pcbgTitle">' +
        '<button type="button" class="pcbg-close" aria-label="Close"></button>' +
        '<h3 class="pcbg-title" id="pcbgTitle">Design your background</h3>' +
        '<p class="pcbg-sub">Our creators will hand-draw a unique pattern for your pet. Make it all about them: a toy, a treat, or a nod to their name.</p>' +
        '<div class="pcbg-field">' +
          '<div class="pcbg-label">Background color <span class="pcbg-picked"></span></div>' +
          '<div class="pcbg-colors">' + dots + '</div>' +
        '</div>' +
        '<div class="pcbg-field">' +
          '<label class="pcbg-label" for="pcbgIcon">What should we draw on it?</label>' +
          '<input type="text" id="pcbgIcon" class="pcbg-input" maxlength="60" placeholder="e.g. tennis balls, red cherries, watercolor stripes…">' +
        '</div>' +
        '<p class="pcbg-note">' + ICON_EYE + '<span>You\'ll receive a preview to approve before anything is printed.</span></p>' +
        '<p class="pcbg-error" hidden>Please choose a color and tell us what to draw.</p>' +
        '<button type="button" class="pcbg-save"><span class="pcbg-save__text">Save my background</span><span class="pcbg-save__icon" aria-hidden="true"></span></button>' +
      '</div>';

    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    overlay.querySelector('.pcbg-close').addEventListener('click', closeModal);

    overlay.querySelectorAll('.pcbg-color').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.color = btn.getAttribute('data-color');
        paintModal();
      });
    });

    overlay.querySelector('#pcbgIcon').addEventListener('input', function (e) {
      state.icon = e.target.value;
    });

    // Guardar: o botão mostra "Saved" (cor um pouco mais escura e o visto a saltar)
    // e a janela fecha sozinha passado ~0,9 s
    overlay.querySelector('.pcbg-save').addEventListener('click', function () {
      var btn = this;
      if (btn.classList.contains('is-saved')) return;
      if (!isValid()) {
        overlay.querySelector('.pcbg-error').hidden = false;
        return;
      }
      syncFields();
      renderSummary();
      btn.classList.add('is-saved');
      btn.querySelector('.pcbg-save__text').textContent = 'Saved';
      btn.setAttribute('aria-live', 'polite');
      savedTimer = setTimeout(closeModal, SAVED_MS);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && !overlay.hidden) closeModal();
    });
  }

  function paintModal() {
    overlay.querySelectorAll('.pcbg-color').forEach(function (btn) {
      var on = btn.getAttribute('data-color') === state.color;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    overlay.querySelector('#pcbgIcon').value = state.icon;
    overlay.querySelector('.pcbg-picked').textContent =
      state.color ? '· ' + state.color : '';
    overlay.querySelector('.pcbg-error').hidden = true;
  }

  function openModal(showError) {
    if (!overlay) buildModal();
    resetSave();
    paintModal();
    if (showError) overlay.querySelector('.pcbg-error').hidden = false;
    overlay.hidden = false;
    document.documentElement.classList.add('pcbg-lock');
    setTimeout(function () {
      var first = state.color ? overlay.querySelector('#pcbgIcon') : overlay.querySelector('.pcbg-color');
      if (first) first.focus({ preventScroll: true });
    }, 50);
  }

  function resetSave() {
    clearTimeout(savedTimer);
    var btn = overlay && overlay.querySelector('.pcbg-save');
    if (!btn) return;
    btn.classList.remove('is-saved');
    btn.querySelector('.pcbg-save__text').textContent = 'Save my background';
  }

  function closeModal() {
    if (!overlay) return;
    resetSave();
    overlay.hidden = true;
    document.documentElement.classList.remove('pcbg-lock');
    syncFields();
    renderSummary();
  }

  /* ---------- eventos ---------- */

  // Escolher o swatch "+" (ou voltar a clicar nele) abre o pop-up
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.petrait-cbg-swatch')) {
      setTimeout(function () { openModal(); }, 0);
    }
  });

  // Mudança de fundo: liga/desliga os campos e o resumo
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'radio' && (t.name || '').indexOf(OPTION_PREFIX) === 0) {
      setTimeout(function () { layoutB(); decorate(); syncFields(); renderSummary(); }, 0);
    }
  });

  // Bloqueia "Next" no passo 1 e o "Add to cart" se o Custom estiver incompleto
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var next = e.target.closest('#petraitNextBtn');
    var atStep1 = document.documentElement.classList.contains('petrait-at-1');
    var buy = e.target.closest('.product__block--buy_buttons button[type="submit"]');
    if ((next && atStep1) || buy) {
      if (isCustomSelected() && !isValid()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openModal(true);
      } else {
        syncFields();
      }
    }
  }, true);

  // Na Review, mostra os detalhes em vez de só "Custom"
  function watchReview() {
    var el = document.getElementById('reviewBg');
    if (!el || el.dataset.cbgWatch) return;
    el.dataset.cbgWatch = '1';
    new MutationObserver(function () {
      if (el.textContent.trim() === VALUE && isValid()) {
        el.textContent = 'Custom — ' + summaryText();
      }
    }).observe(el, { childList: true, characterData: true, subtree: true });
  }

  // O tema volta a desenhar os swatches quando a variante muda: redecorar
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      layoutB();
      decorate();
      watchReview();
    });
  }

  function init() {
    layoutB();
    decorate();
    watchReview();
    var scope = document.querySelector('product-info') || document.querySelector('.product__info-wrapper') || document.getElementById('MainContent');
    if (scope) new MutationObserver(queue).observe(scope, { childList: true, subtree: true });
    // os títulos Solid / Premium chegam um pouco depois (petrait-premium-badge.js)
    setTimeout(queue, 600);
    setTimeout(queue, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
